// @flow

import gql from 'graphql-tag';

type SeoLinkpileLink = {
    test: string,
    url: string
};

type SeoLinkpileCategory = {
    title: string,
    links: [?SeoLinkpileLink]
};

type SeoLinkpile = {
    title?: string,
    categories?: [?SeoLinkpileCategory]
};

export type SeoLinkpileResponseData = {
    seoLinkpile: SeoLinkpile,
    error?: Error,
    loading: boolean,
    variables: {
        path: string
    }
};

const seoLinkpileQuery = gql`
    query seoLinkpileQuery($path: String) {
        seoLinkpile(path: $path) {
            title
            categories {
                title
                links {
                    text
                    url
                }
            }
        }
    }
`;

export default seoLinkpileQuery;
